import { amenitiesAndPhotos, details as locationDetails } from 'pages/locations'

export default [
  // location information
  { path: '/locations/:id/information/details', name: 'locations.information.details', component: locationDetails
    , meta:{permits:['location_user', 'location_management']}},
  { path: '/locations/:id/information/amenities-and-photos', name: 'locations.information.amenitiesAndPhotos', component: amenitiesAndPhotos
    , meta:{permits:['location_user', 'amenity_list', 'locationPhoto_upload']}},
]
